import { useEffect, useState } from "react";
import axios from "axios";
import { KIND_META } from "@/components/sections/marketplaceMapConstants";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Fetches live marketplace status + real geo-tagged opportunities, separate from
// MarketplaceMap's rendering so the component stays focused on the map/filter UI.
export const useMarketplaceMarkers = () => {
  const [live, setLive] = useState(null);
  const [liveMarkers, setLiveMarkers] = useState([]);

  useEffect(() => {
    axios.get(`${API}/marketplace/live`).then((res) => setLive(res.data)).catch(() => setLive(null));
    axios
      .get(`${API}/opportunities`)
      .then((res) => {
        const opps = res.data?.opportunities || [];
        const withCoords = opps
          .filter((o) => Number.isFinite(Number(o.lat)) && Number.isFinite(Number(o.lng)) && KIND_META[o.map_kind])
          .map((o) => ({ kind: o.map_kind, city: o.origin || "Live Opportunity", lat: Number(o.lat), lng: Number(o.lng) }));
        setLiveMarkers(withCoords);
      })
      .catch(() => setLiveMarkers([]));
  }, []);

  return { live, liveMarkers, usingLive: liveMarkers.length > 0 };
};
